import { Masonry, Spin, Splitter } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { get } from '../../Common/api'
import Selectors from './Selectors'
import dayjs from 'dayjs'
import GlobalContext from '../GlobalContext'
import MultipleBoxCharts from './MulitipleBoxCharts'
import SingleBoxCharts from './SingleBoxCharts'

export default function BoxStatistics () {
  const { boxes } = useContext(GlobalContext)
  const [filter, setFilter] = useState({
    start_date: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_date: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    box_ids: boxes.map((box) => box.id)
  })
  const [slots, setSlots] = useState()
  const [loading, setLoading] = useState(false)

  const getData = async () => {
    setLoading(true)
    await get({
      url: 'admin/statistics',
      params: filter,
      onSuccess: (json) => {
        setSlots(json.slots)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (filter) {
      getData()
    }
  }, [filter])

  const displayedCharts = (selectedBoxes, slots) => {
    if (selectedBoxes.length > 1) {
      return MultipleBoxCharts(slots, selectedBoxes)
    } else {
      return SingleBoxCharts(slots, selectedBoxes[0])
    }
  }

  return (
    <Splitter orientation='vertical' style={{ height: '85vh' }}>
      <Splitter.Panel collapsible={{ start: true, end: true, showCollapsibleIcon: true }} max='30%'>
        <Selectors setFilter={setFilter} />
      </Splitter.Panel>
      <Splitter.Panel>
        <Spin spinning={loading}>
          { slots && boxes && <Masonry gutter={16} items={displayedCharts(filter.box_ids, slots)} /> }
        </Spin>
      </Splitter.Panel>
    </Splitter>
  )
}
